import { render, staticRenderFns } from "./MedicineTaking.vue?vue&type=template&id=4b43a6b2&scoped=true&"
import script from "./MedicineTaking.vue?vue&type=script&lang=ts&"
export * from "./MedicineTaking.vue?vue&type=script&lang=ts&"
import style0 from "./MedicineTaking.vue?vue&type=style&index=0&id=4b43a6b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b43a6b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow,VSpacer})
